import { useSearchParams } from "react-router-dom";

export const useStorSelfSearchParams = (...params: string[]): string[] => {
    const [searchParams, setSearchParams] = useSearchParams();

    return params.map(param => searchParams.get(param) || "")
}
